import { useEffect, useState } from 'react';
import ThemeMaker from '../../components/thememaker';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { config } from "../../utils/config";
import axios from 'axios';
import { Paginated } from '../../components/Paginated';
import CircularProgress from '@mui/material/CircularProgress';
import { tokenDecode } from '../../utils/helper';


export default function Productlist() {
    const { apiEndpoint } = config;
    const [productTypes, setproductTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // ── Permission checks ──
    const decoded = tokenDecode();
    const permList: any[] = Array.isArray(decoded?.data?.permission)
        ? decoded.data.permission
        : [];
    const isSuperAdmin =
        Number(decoded?.data?.user?.[0]?.parent_id) === 1 ||
        Number(decoded?.data?.user?.[0]?.id) === 1

    // const botheditable = decoded?.data?.user?.[0]?.seller_id
    // console.log("dfghjk456768989765", botheditable)
    const categoryPerm = isSuperAdmin
        ? { read: true, write: true, update: true, delete: true }
        : permList.find((p: any) => p?.tab_name === 'category') || {};
    const canWrite = isSuperAdmin || Boolean(categoryPerm?.p_write);
    const canUpdate = isSuperAdmin || Boolean(categoryPerm?.p_update);
    const canDelete = isSuperAdmin || Boolean(categoryPerm?.p_delete);
    useEffect(() => {
        getproductTypes()
    }, [])

    async function getproductTypes() {
        try {
            setIsLoading(true)
            const { data } = await axios({
                url: `${apiEndpoint}/snp/products/get-all-type`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
                },

            })
            console.log(data)
            if (data.status === 200 || data.status === true || Array.isArray(data?.data)) {
                setproductTypes(data?.data || [])
                setIsLoading(false)
            } else {
                setIsLoading(false)
                toast.error("Error In Loading Product Type");
            }
        } catch (err) {
            setIsLoading(false)
            toast.error("Error in Getting Product Types")
        }
    }
    async function deleteHandler(id: any) {
        try {
            setIsLoading(true)
            const { data } = await axios({
                url: `${apiEndpoint}/snp/products/delete-type/${id}`,
                method: "DELETE",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
                },
            })

            if (data?.status === 200 || data?.status === true) {
                toast.success(data?.message || "Deleted Successfully");
                getproductTypes();
            } else {
                setIsLoading(false);
                toast.error(data?.message || "Error In Deleting Product Type");
            }
        } catch (err) {
            setIsLoading(false)
            toast.error("Error in API")
        }
    }

    const COLUMNS = [
        {
            Header: "Sn No.",
            Footer: "Sn No.",
            accessor: (row: any, count: any) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "Name",
            Footer: "Name",
            accessor: "name",
            sticky: "left"
        },
        {
            Header: "ONDC Protocol",
            Footer: "ONDC Protocol",
            accessor: (row: any) => {
                return row.ondc_protocol || row.ondc_mapping || "N/A"
            },
            sticky: "Status"
        },
        {
            Header: "Status",
            Footer: "Status",
            accessor: (row: any) => {
                return row.status === true ? 'Active' : "Inactive"
            },
            sticky: "Status"
        },
        {
            Header: "Action",
            Footer: "Action",
            accessor: (row: any) => {
                return (
                    <>
                        {canUpdate && (
                            <Link to={`/producttype/${row.id}`} className="btn btn-warning btn-circle mr-1" title="Edit Product Type">
                                <i className="fas fa-pen"></i>
                            </Link>
                        )}
                        {canDelete && (
                            <button className="btn btn-danger btn-circle" onClick={() => deleteHandler(row.id)} title="Delete Product Type">
                                <i className="fas fa-trash"></i>
                            </button>
                        )}
                        {!canUpdate && !canDelete && (
                            <span className="text-muted small">No Actions</span>
                        )}
                    </>
                )
            },
            sticky: "left"
        },



    ];


    return (
        <ThemeMaker>
            <div className="row w-100 m-0 mt-1">
                <div className="col-md-12 ">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3" style={{ position: "sticky", top: "10px", zIndex: 30, backgroundColor: "#fff" }}>
                            <h6 className="m-0 font-weight-bold text-primary text-left d-flex justify-content-between align-items-center">
                                Product Type List

                                {canWrite && (
                                    <Link to="/producttype">
                                        <button className="btn btn-primary">Add Product Type</button>
                                    </Link>
                                )}

                            </h6>
                        </div>

                        <div className="card-body" style={{ minHeight: "70vh" }}>

                            {!isLoading ? <Paginated data={productTypes} columns={COLUMNS as any} /> : <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}><CircularProgress /></div>}
                        </div>
                    </div>
                </div>
            </div>

        </ThemeMaker >
    )
}
